import { render } from "./Standard.vue?vue&type=template&id=6e2a3e84&scoped=true"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"

import "./Standard.vue?vue&type=style&index=0&id=6e2a3e84&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a3e84"]])

export default __exports__